import * as React from "react"
import { Box } from "@mui/material";

import { useUserApp } from "@hooks";
import { LabelCountry, BadgeVariant } from "@components";


export default function distributionRetailerColumn(sort, name, label, userGroupByProductID=1) {
	return [{
		name, label,
		options: {
			display: 'excluded',
			filterType: 'textField',
			customBodyRowRender: value => value.map(v => v.retailer).join(",")
		}
	}, {
		name: sort, label,
		options: {
			filter: false,
			headerAlign: 'left',
			customBodyRowRenderLite: (_, row) => <RetailerCell data={row[name]} />
		}
	}]
}

const RetailerCell = ({ data }) => {

	const { userGroupByProductID } = useUserApp()

	return <Box sx={{ display: 'flex', flexDirection: 'column' }}>
			{data.map(({ country, retailer, siteURL, numVariants }, idx) => (
				<Box key={idx} sx={{ display: 'flex', alignItems: 'center' }}>
					<LabelCountry
						country={country}
						label={retailer}
					/>
					{!userGroupByProductID && <BadgeVariant numVariants={numVariants} />}
				</Box>
			))}
	</Box>
}